import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { supabase } from "./supabase";
import AdminDashboard from "./pages/AdminDashboard";
import DriverDashboard from "./pages/DriverDashboard";
import "./App.css";
import logow from "./logow.jpg";
import ClientPortal from "./pages/ClientPortal";

/* =======================
   CLIENT DELIVERY PAGE
======================= */
function DeliveryApp() {
  const [step, setStep] = useState(0);
  const [showHelp, setShowHelp] = useState(false);
  const [orderNumber, setOrderNumber] = useState("");

  const [form, setForm] = useState({
  client_name: "",
  phone: "",
  recipient_name: "",
  recipient_phone: "",
  package_type: "",
  pickup: "",
  delivery: "",
  delivery_fee_payer: "",
payment_method: "",
  package_price: "",
});

 

  

  /* =======================
     ORDER CODE
  ======================= */
  const generateOrderCode = () => {
    const ts = Date.now().toString().slice(-6);
    return `A${ts}`;
  };

  /* =======================
     PLACE ORDER
  ======================= */
  const placeOrder = async () => {
    const orderCode = generateOrderCode();

    const { error } = await supabase.from("orders").insert([
      {
        order_code: orderCode,
        client_name: form.client_name,
        phone: form.phone,
        recipient_name: form.recipient_name,
        recipient_phone: form.recipient_phone,
        package_type: form.package_type,
        package_price: form.package_price,
        pickup: form.pickup,
        delivery: form.delivery,
        payment_method: form.payment_method,
        
        status: "En attente",
      },
    ]);

    if (error) {
      alert("Erreur lors de la commande : " + error.message);
      return;
    }

    setOrderNumber(orderCode);
    setStep(3);
  };

  return (
    <div className="app">
      {/* TOP BAR */}
      <header className="topbar">
        <img src={logow} alt="Watamin Livraison" className="logo-img" />
        <button className="help-btn" onClick={() => setShowHelp(true)}>
          Besoin d’aide ?
        </button>
      </header>

      <main className="main">
        {/* INTRO */}
        {step === 0 && (
          <div className="intro">
            <h1>Bienvenue chez Watamin Livraison</h1>
            <p>Votre service de livraison rapide, fiable et securisé. Commandez en quelques secondes et laissez nous faire le reste.</p>

            <div className="action-bar">
              <button className="primary" onClick={() => setStep(1)}>
                Commander une livraison
              </button>
            </div>
          </div>
        )}

        {/* STEP 1 */}
        {step === 1 && (
          <section className="form-section">
            <h2>Informations de livraison</h2>

            <div className="form-grid">
              <div className="field">
                <label>Nom du client</label>
                <input
                  value={form.client_name}
                  onChange={(e) =>
                    setForm({ ...form, client_name: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Téléphone</label>
                <input
                  value={form.phone}
                  onChange={(e) =>
                    setForm({ ...form, phone: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Nom du destinataire</label>
                <input
                  value={form.recipient_name}
                  onChange={(e) =>
                    setForm({ ...form, recipient_name: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Téléphone du destinataire</label>
                <input
                  value={form.recipient_phone}
                  onChange={(e) =>
                    setForm({ ...form, recipient_phone: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Type de colis</label>
                <input
                  value={form.package_type}
                  onChange={(e) =>
                    setForm({ ...form, package_type: e.target.value })
                  }
                />
              </div>
              <div className="field">
  <label>Valeur du colis</label>
  <input
    type="number"
    value={form.package_price}
    onChange={(e) =>
      setForm({ ...form, package_price: e.target.value })
    }
  />
</div>

              <div className="field">
                <label>Adresse de ramassage</label>
                <input
                  value={form.pickup}
                  onChange={(e) =>
                    setForm({ ...form, pickup: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Adresse de livraison</label>
                <input
                  value={form.delivery}
                  onChange={(e) =>
                    setForm({ ...form, delivery: e.target.value })
                  }
                />
              </div>

              <div className="field">
  <label>Payé par</label>
  <select
    value={form.delivery_fee_payer}
    onChange={(e) =>
      setForm({ ...form, delivery_fee_payer: e.target.value })
    }
  >
    <option value="">Choisir</option>
    <option value="Mobile money">Business</option>
    <option value="Espèces">Client</option>
  </select>
</div>

              <div className="field">
                <label>Méthode de paiement</label>
                <select
                  value={form.payment_method}
                  onChange={(e) =>
                    setForm({ ...form, payment_method: e.target.value })
                  }
                >
                  <option value="">Choisir</option>
                  <option value="Especes">Espèces</option>
                  <option value="Mobile">Mobile money</option>
                </select>
              </div>
            </div>

            <div className="action-bar">
              <button
                className="primary"
                disabled={Object.values(form).some((v) => !v)}
                onClick={() => setStep(2)}
              >
                Continuer
              </button>
               <button className="ghost" onClick={() => setStep(0)}>
                Retour
              </button>
            </div>
          </section>
        )}

        {/* STEP 2 SUMMARY */}
        {step === 2 && (
          <section className="form-section">
            <h2>Récapitulatif</h2>

            <div className="summary-grid">
              <div>
                <span>Client</span>
                <strong>{form.client_name}</strong>
              </div>
              <div>
                <span>Téléphone</span>
                <strong>{form.phone}</strong>
              </div>
              <div>
                <span>Destinataire</span>
                <strong>{form.recipient_name}</strong>
              </div>
              <div>
                <span>Tél. destinataire</span>
                <strong>{form.recipient_phone}</strong>
              </div>
              <div>
                <span>Type de colis</span>
                <strong>{form.package_type}</strong>
              </div>
              <div>
                <span>Collecte</span>
                <strong>{form.pickup}</strong>
              </div>
              <div>
                <span>Livraison</span>
                <strong>{form.delivery}</strong>
                <span>Payé par</span>
                <strong>{form.delivery_fee_payer}</strong>
              </div>
            </div>

            <div className="action-bar">
              
              <div>
                <button className="ghost" onClick={() => setStep(1)}>
                  Modifier
                </button>
                <button className="primary" onClick={placeOrder}>
                  Confirmer
                </button>
              </div>
            </div>
          </section>
        )}

        {/* STEP 3 SUCCESS */}
        {step === 3 && (
          <section className="success-section">
            <h2>Commande confirmée</h2>
            <p>Numero de commande :</p>
            <div className="order-number">{orderNumber}</div>
            <p>Le livreur vous contactera a l'approche de l'addresse de livraison !</p>
            <button className="primary" onClick={() => setStep(0)}>
              Nouvelle livraison
            </button>
          </section>
        )}
      </main>

      {/* HELP MODAL */}
      {showHelp && (
        <div className="modal-overlay" onClick={() => setShowHelp(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Besoin d’aide ?</h3>
            <p>
              Contactez le support Watamin <br />
              <strong>📞 +22650070511</strong>
            </p>
            <button className="primary" onClick={() => setShowHelp(false)}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* =======================
   ROUTES
======================= */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DeliveryApp />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/driver" element={<DriverDashboard />} />
        <Route path="/clients" element={<ClientPortal />} />
      </Routes>
    </BrowserRouter>
  );
}

